


















































import Vue from 'vue';
import moment from 'moment';
import { getCookie, eraseCookie } from '@/common/utils/Http';
import commonVuex from '../vuex/common';
import commonClient from '../apis';
import AccountBox from './AccountBox.vue';
import userClient from '../../user/apis';
import TrialTips from './TrialTips.vue';
import Disclaimer from './Disclaimer.vue';

interface NavItem {
  name: string;
  alias: string;
}
const currentAlias = '';

const showDisclaimerAcc = ['路创'];

const navs: NavItem[] = [
  { name: '客户管理', alias: 'customer' },
  { name: '自动化营销', alias: 'rule' },
  { name: '客户群发', alias: 'mass'},
  { name: '设置', alias: 'settings' },
];

export default Vue.extend({
  mixins: [commonVuex],
  components: {
    AccountBox,
    TrialTips,
    Disclaimer,
  },
  data() {
    return {
      navs,
      showAccountBox: false,
      currentAlias,
      inAccountBox: false,
      timeout: null,
      avatar: '',
      currentTime: null,
      disclaimerAccepted: false,
      /* tslint:disable */
    };
  },
  props: {
    showNavs: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showDisclaimer(): boolean {
      return this.account && this.account.weixinName && showDisclaimerAcc.indexOf(this.account.weixinName) !== -1 && !this.disclaimerAccepted
    },
    isLogin(): boolean {
      return getCookie('DRIP_SESSION_KEY_USER_IDENTITY') !== null
    },
    expireStatus(): any {
      const isCustomer = this.currentAlias === 'customer';
      const curr = this.currentTime;
      const l: any = this.accountState && this.accountState.crmLevel;
      const expired: any = l && l.expired && moment(l.expired);
      if(isCustomer && curr && expired) {
        const days: number = expired.diff(curr, 'days')
        return {
          show: days <= 30,
          days,
        };
      } else {
        return {
          show: false,
        };
      }
    },
  },
  methods: {
    updateDisclaimer() {
      const fromLocal = window.localStorage.getItem('acceptDisclaimer');
      console.log(fromLocal);
      this.disclaimerAccepted = (fromLocal !== null && fromLocal !== 'null');
      console.log(this.disclaimerAccepted)
    },
    upgrade() {
      this.$router.push('/upgrade/buy');
    },
    showNavItem(nav: any) {
      if (nav.alias === 'settings') {
        if (this.account.weixinType !== 1) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    selectedStatus(nav: NavItem): string {
      return nav.alias === this.currentAlias ? 'selected' : '';
    },
    getCurrentModule(path: string): string {
      const r = path.match(/^\/.*\//);
      if (r) {
        return r[0].replace(/\//g, '');
      } else {
        return '';
      }
    },
    closeAccountBox() {
      this.timeout = setTimeout(() => {
        this.showAccountBox = false;
      }, 300)
    },
    displayAccountBox() {
      clearTimeout(this.timeout);
      this.showAccountBox = true;
    },
    loginOut () {
      userClient.loginOut({}).success((r) => {
        this.showAccountBox = false;
        window.localStorage.removeItem('account');
        this.$store.commit('LOGIN_OUT');
        eraseCookie('trialTips')
        window.location.href = '#/user/login'
      }).error((r) => ({}));
    },
  },
  mounted() {
    commonClient.getTime({}).success((r) => {
      this.currentTime = moment(r);
    });
    this.currentAlias = this.getCurrentModule(this.$route.path);
    this.avatar = (this.account && this.account.avatar) ? this.account.avatar.replace('http://', 'https://') : null;
    this.updateDisclaimer();
  },
  watch: {
    $route(to, from) {
      this.currentAlias = this.getCurrentModule(to.fullPath);
    },
    'account.avatar' () {
      this.avatar = (this.account && this.account.avatar) ? this.account.avatar.replace('http://', 'https://') : null;
    },
  },
});
